<template>
	<div class="page">
		<gc-header headerData="moduleDetails"></gc-header>
		<div class="page-main">
			<gc-group-detail :data="basicInfoData"></gc-group-detail>
			<div class="table-content" v-loading="loading">
				<gc-table
					border
					:showPage="true"
					:columns="columns"
					:table-data="tableData"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					paginationLayout="prev, next, jumper"
					@current-page-change="handleCurrentPageChange"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetImeiModuleDetails, apiGetOperateLogPageList } from '@/apis/communicationModelManage.api'
export default {
	name: 'moduleDetails',
	data() {
		return {
			id: this.$route.query.id,
			uuid: this.$route.query.uuid,
			moduleDetails: {},
			columns: [
				{ key: 'operationType', name: '操作类型' },
				{ key: 'operatorName', name: '操作人' },
				{ key: 'operationTime', name: '操作时间' },
				{ key: 'operationInfo', name: '操作后信息', tooltip: true },
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
		}
	},
	computed: {
		basicInfoData() {
			const d = this.moduleDetails
			return {
				title: '模组信息',
				row: 4,
				list: [
					{
						key: 'deviceNo',
						label: '设备通讯编号',
						value: d.deviceNo,
					},
					{
						key: 'imei',
						label: 'IMEI',
						value: d.imei,
					},
					{
						key: 'deviceTypeName',
						label: '设备类型',
						value: d.deviceTypeName,
					},
					{
						key: 'deviceGroupName',
						label: '设备组',
						value: d.deviceGroupName,
					},
					{
						key: 'manufacturerName',
						label: '厂商名称',
						value: d.manufacturerName,
					},
					{
						key: 'statusName',
						label: '注册状态',
						value: d.statusName,
					},
					{
						key: 'createTime',
						label: '创建时间',
						value: d.createTime,
					},
				],
			}
		},
	},

	created() {
		this.queryImeiModuleDetails()
		this.queryTableDataPageList()
	},

	methods: {
		async queryImeiModuleDetails() {
			const data = await apiGetImeiModuleDetails(this.id)
			this.moduleDetails = data
		},

		async queryTableDataPageList() {
			this.loading = true
			const searchParams = {
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				logType: '3',
				relatedId: this.uuid,
			}
			try {
				const { records = [], total } = await apiGetOperateLogPageList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
.page-main {
	flex-direction: column;
	padding: 0 20px;
	.table-content {
		flex: 1;
		height: 0;
		padding: 12px 0;
	}
}
</style>
